<script>
export default {};
</script>
<template>
  <div class="underbtn">
    <div class="btn">
      <div class="name">LinkedIn Premium</div>
      <div class="con">Special features only for premium users</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.underbtn {
  padding: 20px;
  border-top: 1px solid #f4f4f4;
  .btn {
    border-radius: 4px;
    color: #fff;
    background: linear-gradient(to bottom, #d8c281, #ac9b69);
    line-height: 1.5;
    padding: 10px 20px;
    .name {
      font-size: 12px;
      font-weight: 600;
    }
    .con {
      font-size: 10px;
      font-weight: 100;
    }
  }
}
</style>
